<template>

    <div>
        <article class="article1__container">

            <div class="article__wrapper-row">

                <div class="article1__bloc-right">

                    <h1 class="article1__title">{{ $t('landing_consent_title_landing') }}</h1>

                    <p class="article1__subtitle">{{ $t('landing_consent_banner_description') }}</p>

                    <div class="article1__input-container" @click.self="focusInputV4">

                        <input ref="inputv4" :placeholder="$t('landing_web_placeholder')" class="article1__input"
                               type="email" v-on:keyup.enter="goLoginEvent($refs.inputv4.value)">

                        <img alt="text decoration" class="article1__input-logo"
                             src="/img/partner/shine-white-right.svg">

                    </div>

                    <a v-if="!isDesktop"
                       :href="makeHref('/login/email')"
                       class="article1__btn-mobile mt__8"
                       @click.prevent="goLoginEvent($refs.inputv4.value)"
                    >
                        <lottie-loader v-if="requesting" class="btn-loader"></lottie-loader>
                        <span v-else>{{ $t('landing_consent_cta') }}</span>
                    </a>

                </div>

            </div>

            <a class="article1__anchor" href="#privacy">{{ $t('landing_consent_your_data') }}</a>

            <img v-if="!isDesktop" class="article1__waves" src="/img/landing/waves-min.svg">

        </article>
    </div>

</template>

<script>

import Vuex from 'vuex'

import Tag from '../../modules/tag'

import LottieLoader from '../../components/lottie/LottieLoader'

export default {

    name: 'article-1-mobile-default',

    components: {LottieLoader},

    props: {
        requesting: {
            type: Boolean,
            default: false
        }
    },

    computed: {

        ...Vuex.mapGetters([
            'lang'
        ])
    },

    methods: {

        focusInputV4() {
            this.$refs.inputv4.focus()
        },

        goLoginEvent(email) {
            this.$emit('goLogin', email)
        },

        clickAmplitude(event) {

            Tag.clickAmplitude(this, event)

        }

    }
}
</script>

<style lang="scss" scoped>

.article1 {

    &__container {
        position: relative;
        display: flex;
        align-items: center;
        background-image: url('/img/background/fetch-mobile.svg');
        background-repeat: no-repeat;
        background-position: bottom;
        background-size: cover;
        justify-content: center;
        padding: 32px 16px;
        flex-direction: column;
        @media screen and (min-width: $above-mobile-length) {
            padding: 200px 80px 280px;
            flex-direction: row;
            background-image: url('/img/background/landing-v4-desktop-background.svg');
        }
    }

    &__bloc-right {
        flex: 1;
        color: $white;
        justify-content: center;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    &__title {
        font-size: 34px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.18;
        letter-spacing: normal;
        text-align: center;
        @media screen and (min-width: $above-mobile-length) {
            font-size: 36px;
            line-height: 1.14;
            letter-spacing: -0.5px;
            font-weight: 800;
            text-shadow: 0 0 25px rgba(0, 0, 0, 0.1);
        }
    }

    &__subtitle {
        text-shadow: 0 0 25px rgba(0, 0, 0, 0.1);
        font-size: 17px;
        line-height: 1.41;
        margin-top: 8px;
        @media screen and (min-width: $above-mobile-length) {
            opacity: 0.88;
            font-weight: 500;
        }
    }

    &__input-container {
        margin-top: 24px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: row;
        height: 61px;
        background-color: $white;
        border-radius: 32px;
        box-shadow: 0 25px 50px 0 rgba(0, 0, 0, 0.1);
        padding: 4px;
        max-width: 544px;
        position: relative;
    }

    &__input {
        flex: 1;
        height: 61px;
        border-radius: 32px;
        margin: 20px;
        font-size: 16px;
        line-height: 1.31;
        @media screen and (min-width: $above-mobile-length) {
            margin-right: 0px;

            &:lang(ar-sa) {
                margin: 20px;
                margin-left: 0;
            }
        }
    }

    &__button {
        height: 53px;
        width: auto;
        padding: 0 24px;
        overflow: hidden;
    }

    &__button-text {
        white-space: nowrap;
    }

    &__input-logo {
        position: absolute;
        right: -40px;
        width: 24px;
        object-fit: contain;

        &:lang(ar-sa) {
            right: unset;
            left: -40px;
            transform: rotate(180deg);
        }
    }


    &__btn-mobile {
        width: 100%;
        height: 64px;
        padding: 20px;
        border-radius: 56px;
        background-color: $midnight;
        font-size: 16px;
        font-weight: bold;
        line-height: 1.5;
        text-align: center;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &__anchor {
        position: relative;
        font-weight: bold;
        letter-spacing: normal;
        color: $white;
        text-decoration: underline;
        margin-top: 240px;
        font-size: 14px;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.43;
        text-align: center;
        @media screen and (min-width: $above-mobile-length) {
            position: absolute;
            bottom: 40px;
            margin-top: 0;
            line-height: 1.4;
            font-size: 17px;
        }
    }

    &__waves {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 8px;
        object-fit: contain;
    }

}


.btn-loader {
    position: absolute;
}

.btn-hidden {
    visibility: hidden;
}
</style>

